import React from 'react';
import {GenericErrorMsg} from '~/entities/dialogs';
import {
    ForgotPasswordFinishErrorCode,
    useForgotPasswordFinishMutation,
} from '~/processes/onboarding/api/forgot-password/forgotPassword';
import {SetPasswordForm} from '~/processes/onboarding/ui/shared/SetPasswordForm';
import {useAppDispatch} from '~/shared/store';

type SetPasswordProps = {
    username: string;
    uuid: string;
    onPasswordSet: (password: string) => void;
    onSessionExpired: () => void;
};

export function SetPassword({username, uuid, onPasswordSet, onSessionExpired}: SetPasswordProps) {
    const dispatch = useAppDispatch();

    const handleError = (e: unknown) => {
        dispatch(GenericErrorMsg.open());
        throw e;
    };

    const {mutateAsync: setupPassword, isPending} = useForgotPasswordFinishMutation();

    const handleSubmit = async (password: string) => {
        const {problem} = await setupPassword({username, uuid, password}).catch(handleError);

        if (problem) {
            switch (problem.error_code) {
                case ForgotPasswordFinishErrorCode.validationFailed: {
                    return problem.issues;
                }
                case ForgotPasswordFinishErrorCode.codeExpired: {
                    onSessionExpired();
                    return;
                }
                default: {
                    dispatch(GenericErrorMsg.open());
                    return;
                }
            }
        }

        onPasswordSet(password);
    };

    return <SetPasswordForm onSubmit={handleSubmit} isPending={isPending} />;
}
